import React, { useEffect, useState, ChangeEvent } from "react";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import CustomLoader from "../components/LoaderComponent";
import { customHeader, paginationOptions } from "../utils/StyledDataTable";
import { TableContainer } from "../utils/StyledComponents";
import { getAllAudit } from "../api/fetchLogs";
import { LogFilters, LogsInterface } from "../utils/Type";

const LogsTable: React.FC = () => {
    const [filters, setFilters] = useState<LogFilters>({});
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [pending, setPending] = useState(true);
    const [datas, setDatas] = useState<LogsInterface[]>([]);

    const fetchData = async () => {
        setPending(true);
        try {
            const result = await getAllAudit(filters);
            if (Array.isArray(result)) {
                setDatas(result);
            } else {
                setDatas([]);
            }
            setResetPaginationToggle(r => !r);
        } catch (error) {
            console.error(error);
            setDatas([]);
        } finally {
            setPending(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (
        e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFilters(f => ({
            ...f,
            [name]: value || undefined
        }));
    };

    const handleSearch = () => {
        fetchData();
    };

    const handleReset = () => {
        setFilters({});
        fetchData();
    };

    const columns = [
        {
            name: "Niveau",
            selector: (row: LogsInterface) => row.level,
            sortable: true,
            width: '6%'
        },
        {
            name: "Utilisateur",
            selector: (row: LogsInterface) => row.username,
            sortable: true,
            width: '15%'
        },
        {
            name: "Message",
            selector: (row: LogsInterface) => row.message,
            sortable: true
        },
        {
            name: "Exception",
            selector: (row: LogsInterface) => row.exception,
            sortable: true,
            width: '15%'
        },
        {
            name: "Date",
            selector: (row: LogsInterface) =>
                format(new Date(row.timestamp), "dd/MM/yyyy HH:mm", { locale: fr }),
            sortable: true,
            width: '10%'
        }
    ];

    return (
        <div className="custom-content">
            <div className="custom-header">
                <span className="custom-title">Les Logs</span>
            </div>

            {/* Bandeau de filtres */}
            <div className="filter-bar" style={{ margin: "1rem 0", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                <input
                    type="text"
                    name="user"
                    className="custom-input-log"
                    placeholder="Utilisateur (email)"
                    value={filters.user || ""}
                    onChange={handleInputChange}
                    style={{width: "200px"}}
                />
                <input
                    type="datetime-local"
                    className="custom-input-log"
                    name="start"
                    placeholder="Date début"
                    value={filters.start || ""}
                    onChange={handleInputChange}
                />
                <input
                    type="datetime-local"
                    className="custom-input-log"
                    name="end"
                    placeholder="Date fin"
                    value={filters.end || ""}
                    onChange={handleInputChange}
                />
                <select name="level" className="custom-input-log" value={filters.level || ""} onChange={handleInputChange}>
                    <option value="">Tous niveaux</option>
                    <option value="TRACE">TRACE</option>
                    <option value="DEBUG">DEBUG</option>
                    <option value="INFO">INFO</option>
                    <option value="WARN">WARN</option>
                    <option value="ERROR">ERROR</option>
                </select>
                <button onClick={handleSearch} className="btn-add-circle">Rechercher</button>
                <button onClick={handleReset} className="btn-add-circle">Réinitialiser</button>
            </div>

            <TableContainer>
                <DataTable
                    columns={columns}
                    data={datas}
                    pagination
                    paginationResetDefaultPage={resetPaginationToggle}
                    persistTableHead
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 200px)"
                    progressPending={pending}
                    progressComponent={<CustomLoader />}
                    customStyles={customHeader}
                    paginationComponentOptions={paginationOptions}
                    noDataComponent={<p style={{ marginTop: "20px" }}>Aucun enregistrement trouvé.</p>}
                />
            </TableContainer>
        </div>
    );
};

export default LogsTable;
